/**
=========================================================
* Iris Design Limited  Fulfilment POD - v2.2.0
=========================================================

* Product Page: https://www.irisdesignlimited.com/product/material-dashboard-react
* Copyright 2023 Dev Iris Design Limited Company (https://www.irisdesignlimited.com)

Coded by www.irisdesignlimited.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/**
 * The base colors for the Iris Design Limited  Fulfilment POD.
 * You can add new color using this file.
 * You can customized the colors for the entire Iris Design Limited  Fulfilment POD using thie file.
 */

const colors = {
  background: {
    default: "#F7F9FC",
  },

  text: {
    main: "#64748B",
    focus: "#475569",
  },

  transparent: {
    main: "transparent",
  },

  white: {
    main: "#ffffff",
    focus: "#ffffff",
  },

  black: {
    light: "#000000",
    main: "#000000",
    focus: "#000000",
  },

  primary: {
    main: "#4D7CFE",
    focus: "#3B68F0",
  },

  secondary: {
    main: "#64748B",
    focus: "#475569",
  },

  info: {
    main: "#4D7CFE",
    focus: "#3B68F0",
  },

  success: {
    main: "#10B981",
    focus: "#059669",
  },

  warning: {
    main: "#F59E0B",
    focus: "#D97706",
  },

  error: {
    main: "#EF4444",
    focus: "#DC2626",
  },

  light: {
    main: "#EDF2F7",
    focus: "#E2E8F0",
  },

  dark: {
    main: "#1E293B",
    focus: "#0F172A",
  },

  grey: {
    100: "#F8FAFC",
    200: "#F1F5F9",
    300: "#E2E8F0",
    400: "#CBD5E1",
    500: "#94A3B8",
    600: "#64748B",
    700: "#475569",
    800: "#334155",
    900: "#1E293B",
  },

  gradients: {
    primary: {
      main: "#6B93FF",
      state: "#4D7CFE",
    },

    secondary: {
      main: "#94A3B8",
      state: "#64748B",
    },

    info: {
      main: "#6B93FF",
      state: "#4D7CFE",
    },

    success: {
      main: "#34D399",
      state: "#10B981",
    },

    warning: {
      main: "#FBBF24",
      state: "#F59E0B",
    },

    error: {
      main: "#F87171",
      state: "#EF4444",
    },

    light: {
      main: "#F8FAFC",
      state: "#EDF2F7",
    },

    dark: {
      main: "#334155",
      state: "#1E293B",
    },
  },

  socialMediaColors: {
    facebook: {
      main: "#3b5998",
      dark: "#344e86",
    },

    twitter: {
      main: "#55acee",
      dark: "#3ea1ec",
    },

    instagram: {
      main: "#125688",
      dark: "#0e456d",
    },

    linkedin: {
      main: "#0077b5",
      dark: "#00669c",
    },

    pinterest: {
      main: "#cc2127",
      dark: "#b21d22",
    },

    youtube: {
      main: "#e52d27",
      dark: "#d41f1a",
    },

    vimeo: {
      main: "#1ab7ea",
      dark: "#13a3d2",
    },

    slack: {
      main: "#3aaf85",
      dark: "#329874",
    },

    dribbble: {
      main: "#ea4c89",
      dark: "#e73177",
    },

    github: {
      main: "#24292e",
      dark: "#171a1d",
    },

    reddit: {
      main: "#ff4500",
      dark: "#e03d00",
    },

    tumblr: {
      main: "#35465c",
      dark: "#2a3749",
    },
  },

  badgeColors: {
    primary: {
      background: "#E8EEFF",
      text: "#3B68F0",
    },

    secondary: {
      background: "#EDF2F7",
      text: "#64748B",
    },

    info: {
      background: "#E8EEFF",
      text: "#3B68F0",
    },

    success: {
      background: "#D1FAE5",
      text: "#047857",
    },

    warning: {
      background: "#FEF3C7",
      text: "#B45309",
    },

    error: {
      background: "#FEE2E2",
      text: "#DC2626",
    },

    light: {
      background: "#FFFFFF",
      text: "#94A3B8",
    },

    dark: {
      background: "#E2E8F0",
      text: "#1E293B",
    },
  },

  coloredShadows: {
    primary: "#4D7CFE",
    secondary: "#64748B",
    info: "#4D7CFE",
    success: "#10B981",
    warning: "#F59E0B",
    error: "#EF4444",
    light: "#94A3B8",
    dark: "#1E293B",
  },

  inputBorderColor: "#E2E8F0",

  tabs: {
    indicator: { boxShadow: "#ddd" },
  },
};

export default colors;
